import Swiper from "swiper";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

const initHomeServicesSliders = () => {
    document.querySelectorAll('[data-home-services-slider]').forEach((root) => {
        const section = root.closest('.home-services');
        const previousButton = section?.querySelector('.home-services__controls .prev');
        const nextButton = section?.querySelector('.home-services__controls .next');
        const desktopQuery = window.matchMedia('(min-width: 992px)');
        let swiper;

        const syncSlider = () => {
            if (desktopQuery.matches) {
                swiper?.destroy(true, true);
                swiper = undefined;

                return;
            }

            if (!swiper) {
                swiper = new Swiper(root, {
                    modules: [Navigation],
                    slidesPerView: 1,
                    spaceBetween: 16,
                    navigation: {
                        prevEl: previousButton,
                        nextEl: nextButton,
                    },
                    breakpoints: {
                        768: {
                            slidesPerView: 2,
                            spaceBetween: 20,
                        },
                    },
                });
            }
        };

        syncSlider();
        desktopQuery.addEventListener('change', syncSlider);
    });
};

if ('loading' === document.readyState) {
    document.addEventListener('DOMContentLoaded', initHomeServicesSliders, { once: true });
} else {
    initHomeServicesSliders();
}
